function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.5,8A8.5,8.5,0,1,0,25,16.5,8.5,8.5,0,0,0,16.5,8Zm0,15.355A6.855,6.855,0,1,1,23.355,16.5,6.853,6.853,0,0,1,16.5,23.355Zm3.489-8.987L17.857,16.5l2.132,2.132a.412.412,0,0,1,0,.583l-.775.775a.412.412,0,0,1-.583,0L16.5,17.857l-2.132,2.132a.412.412,0,0,1-.583,0l-.775-.775a.412.412,0,0,1,0-.583L15.143,16.5l-2.132-2.132a.412.412,0,0,1,0-.583l.775-.775a.412.412,0,0,1,.583,0L16.5,15.143l2.132-2.132a.412.412,0,0,1,.583,0l.775.775a.412.412,0,0,1,0,.583Z",
  transform: "translate(-8 -8)"
});

var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/Cross.1caaa778.svg";
export { SvgCross as ReactComponent };